<div class="m-10 flex-col-container">
    <div class='flex-row-container'>
        <mat-form-field appearance="fill">
            <mat-label>Charts</mat-label>
            <mat-select>
            <mat-option *ngFor="let chart of charts" [value]="chart.chartType" (onSelectionChange)="selectChart($event, chart.chartType)">
                {{chart.desc}}
            </mat-option>
            </mat-select>
        </mat-form-field>          
    </div>
    <div class="flex-col-center">
        <mat-divider class="" style="width: 100%"></mat-divider>
    </div>
    <div class="m-t10 flex-row-container" >        
        <gp-line-chart *ngIf="selectedChartType==='LINE'" style="width: 100%"> </gp-line-chart>
        <!-- <gp-line-chart *ngIf="selectedChartType==='PIE'"></gp-line-chart>
        <gp-line-chart *ngIf="selectedChartType==='AREA'"></gp-line-chart>
        <gp-line-chart *ngIf="selectedChartType==='SCATTER'"></gp-line-chart>         -->
    </div>
</div>